// common.ts
export const BASE_URL = process.env.REACT_APP_BASE_URL!;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL!;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY!;
